export default __webpack_public_path__ + "static/media/screenshot2.2036186e.jpg";